<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Teams</h1>

        <v-row>
            <v-col cols="10">
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-select :items="statuses"
                          label="Status"
                          item-text="name"
                          item-value="id"
                          v-model="status_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="teams"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.status="props">
                <span class="font-weight-bold"
                      :class="props.item.status ? 'green--text' : 'green--text text--lighten-1'">
                    {{props.item.status ? 'Finished' : 'In Progress'}}
                </span>
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-1" @click="[$refs.edit.dialog = true, selectedTeam = props.item.id]">
                    <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                    <span class="green--text">Edit</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="[$refs.delete.dialog = true, selectedTeam = props.item.id]">
                    <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                    <span class="red--text">Delete</span>
                </v-btn>

                <v-btn text class="px-0 mx-1 members" :to="{name : 'AdminStudents', query: {team_id : props.item.id}}">
                    <svg v-svg="'icon-members'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>Members</span>
                </v-btn>

                <v-btn text class="px-0 ml-2" @click="[$refs.settings.dialog = true, selectedTeam = props.item.id]">
                    <svg v-svg="'icon-settings'" size="12" class="mr-1"></svg>
                    <span class="settings">Settings</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <v-btn color="green" width="52" height="52" class="create" fab fixed bottom @click="$refs.create.dialog = true">
            <svg v-svg="'icon-create'" size="21"></svg>
        </v-btn>

        <edit ref="edit" :team_id="selectedTeam"></edit>
        <delete ref="delete" :team_id="selectedTeam"></delete>
        <settings ref="settings" :team_id="selectedTeam"></settings>
        <create ref="create"></create>
    </section>
</template>

<script>
    import Edit from '@/components/Admin/Teams/Edit';
    import Delete from '@/components/Admin/Teams/Delete';
    import Settings from '@/components/Admin/Teams/Settings';
    import Create from '@/components/Admin/Teams/Create';
    export default {
        components : {
            Edit,
            Delete,
            Settings,
            Create,
        },
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedTeam: null,
                keyword: null,
                status_id: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Name', sortable: false, value: 'name'},
                    {text: 'Members', sortable: false, value: 'users_count'},
                    {text: 'Teacher', sortable: false, value: 'teacher_name'},
                    {text: 'Stage', sortable: false, value: 'stage'},
                    {text: 'Status', sortable: false, value: 'status'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
                pagination: {},
                teams: [],
                statuses: [
                    {id: 2, name: 'All'},
                    {id: 0, name: 'In Progress'},
                    {id: 1, name: 'Finished'}
                ]
            }
        },

        mounted(){
            this.getData();
            this.$on('getTeams', function () {
                this.getData();
            })
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        methods: {
            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('teams').get({params: {page: page, status_id: this.status_id, teacher_id: this.$route.query.teacher_id, keyword: this.keyword}}).then((res) => {
                    const response = res.data.teams;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.teams = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Teams/index";
</style>